import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

var Input = React.forwardRef(function Input2({ className, type, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    "input",
    {
      type,
      ref,
      className: cn(
        "flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        className
      ),
      ...props
    }
  );
});

export { Input };
//# sourceMappingURL=chunk-VYHSTPFS.js.map
//# sourceMappingURL=chunk-VYHSTPFS.js.map